import QuizParticipantsService from "services/QuizParticipantsService";

const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const getQuizParticipants = createAsyncThunk(
  "quizParticipants/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await QuizParticipantsService.getQuizParticipants();
      return response.data?.data?.participants || response.data?.participants || [];
    } catch (error) {
      return rejectWithValue(error.response || "Internal server error");
    }
  }
);

export const getQuizParticipantById = createAsyncThunk(
  "quizParticipants/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await QuizParticipantsService.getQuizParticipantById(id);
      return response.data?.data?.participant || response.data?.participant || null;
    } catch (error) {
      return rejectWithValue(error.response || "Internal server error");
    }
  }
);

export const generateParticipantCertificate = createAsyncThunk(
  "quizParticipants/generateCertificate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await QuizParticipantsService.generateCertificate(id);
      return response.data?.data?.certificationUrl || response.data?.data?.certificationUrl || null;
    } catch (error) {
      return rejectWithValue(error.response || "Internal server error");
    }
  }
);

export const deleteQuizParticipant = createAsyncThunk(
  "quizParticipants/delete",
  async (id, { rejectWithValue }) => {
    try {
      await QuizParticipantsService.deleteQuizParticipant(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response || "Internal server error");
    }
  }
);

const initialState = {
  quizParticipants: [],
  quizParticipant: null,
  loading: false,
  error: null,
  success: false,
};

const quizParticipantsSlice = createSlice({
  name: "quizParticipants",
  initialState,
  reducers: {
    clearSuccess: (state) => {
      state.success = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getQuizParticipants.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuizParticipants.fulfilled, (state, action) => {
        state.loading = false;
        state.quizParticipants = action.payload;
        state.error = null;
      })
      .addCase(getQuizParticipants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getQuizParticipantById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuizParticipantById.fulfilled, (state, action) => {
        state.loading = false;
        state.quizParticipant = action.payload;
        state.error = null;
      })
      .addCase(getQuizParticipantById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(generateParticipantCertificate.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateParticipantCertificate.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(generateParticipantCertificate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteQuizParticipant.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteQuizParticipant.fulfilled, (state, action) => {
        state.loading = false;
        state.quizParticipants = state.quizParticipants.filter((participant) => participant._id !== action.payload);
        state.success = true;
        state.error = null;
      })
      .addCase(deleteQuizParticipant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSuccess, clearError } = quizParticipantsSlice.actions;
export default quizParticipantsSlice.reducer;